import { render } from "./AppSpinner.vue?vue&type=template&id=1d64469a&scoped=true&ts=true"
import script from "./AppSpinner.vue?vue&type=script&lang=ts"
export * from "./AppSpinner.vue?vue&type=script&lang=ts"

import "./AppSpinner.vue?vue&type=style&index=0&id=1d64469a&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d64469a"]])

export default __exports__